import { render } from "./CombinationTherapy1.vue?vue&type=template&id=b3dc996e&scoped=true"
import script from "./CombinationTherapy1.vue?vue&type=script&lang=js"
export * from "./CombinationTherapy1.vue?vue&type=script&lang=js"

import "./CombinationTherapy1.vue?vue&type=style&index=0&id=b3dc996e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3dc996e"],['__file',"src/views/pharmarcy/CombinationTherapy1.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b3dc996e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b3dc996e', __exports__)) {
    api.reload('b3dc996e', __exports__)
  }
  
  module.hot.accept("./CombinationTherapy1.vue?vue&type=template&id=b3dc996e&scoped=true", () => {
    api.rerender('b3dc996e', render)
  })

}


export default __exports__